"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getSuccessStatusForLeafNode(successCriteria, scaledScore, minScaledScore, completionStatus, isGraded) {
    switch (successCriteria) {
        case 'minScaledScore': {
            if (isGraded && completionStatus === 'complete') {
                if (scaledScore >= minScaledScore) {
                    return 'pass';
                }
                return 'fail';
            }
            return 'na';
        }
        default:
            console.info('Invalid success criteria' + successCriteria);
    }
    return 'na';
}
exports.getSuccessStatusForLeafNode = getSuccessStatusForLeafNode;
//# sourceMappingURL=getSuccessStatusForLeafNode.js.map